import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/queries/api-client'
import { ConfigSchema } from '@/types/config'

export function useConfig() {
  return useQuery({
    queryKey: ['config'],
    queryFn: async () => {
      const res = await apiClient.get('config')
      return ConfigSchema.parse(res.data.config)
    },
    staleTime: 1000 * 60,
  })
}
